
import API_PATH from '../../../config/API_PATH'
import { GET_AUCTION_RECORD, GET_CURRENT_USER, GET_LIST_PACKAGE, GET_PACKAGE_HISTORY, GET_TURN_REMAIN, GET_WINNER_MONTH, INCREASE_COACH_MARK, LOGIN_OTP, LOGIN_PASSWORD, LOGOUT_USER, REGISTER_RETAIL_PACKAGE, REGISTER_SUB_PACKAGE, REQUEST_OTP, SET_CURRENT_USER, SET_PU4_NEVER_SHOW, TOTAL_PIECECOLLECTED, UPDATE_INFORMATION_NAME, UPDATE_PASSWORD, UPDATE_USER_INFO, UPLOAD_FILE, VERIFY_OTP, VERIFY_OTP_PASSWORD } from './contants'


export const getCurrentUser = data => {
	return {
		type: GET_CURRENT_USER,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.getUser,
			query: data?.query || {},
			callback: data?.callback || null
		},
	}
}
export const getTurnRemain = data => {
	return {
		type: GET_TURN_REMAIN,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.getRemainTurn,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const loginWithPassword = data => {
	return {
		type: LOGIN_PASSWORD,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.login,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const requestOtp = data => {
	return {
		type: REQUEST_OTP,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.getOTP,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const loginWithOtp = data => {
	return {
		type: LOGIN_OTP,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.loginWithSMS,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const verifyOtp = data => {
	return {
		type: VERIFY_OTP,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.verify,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getPackageHistory = data => {
	return {
		type: GET_PACKAGE_HISTORY,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.getPackageList,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getAuctionRecord = data => {
	return {
		type: GET_AUCTION_RECORD,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.getBidHistory,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const verifyOtpPassword = data => {
	return {
		type: VERIFY_OTP_PASSWORD,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.verifyChangePass,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const updatePassword = data => {
	return {
		type: UPDATE_PASSWORD,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.updatePassword,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const logoutUser = data => {
	return {
		type: LOGOUT_USER,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.logout,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getListPackage = data => {
	return {
		type: GET_LIST_PACKAGE,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.packs,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const registerSubPackage = data => {
	return {
		type: REGISTER_SUB_PACKAGE,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.registerPack,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const registerRetailPackage = data => {
	return {
		type: REGISTER_RETAIL_PACKAGE,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.registerMytelPack,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}

export const uploadFile = (data, callback) => {
	return {
		type: UPLOAD_FILE,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.upload,
			query: data.query || {},
			callback: callback || null
		},
	}
}
export const updateUserInfo = (data) => {
	return {
		type: UPDATE_USER_INFO,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.updateInformation,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}

export const setRedisUpdateUserInfo = (data) => {
	return {
		type: SET_CURRENT_USER,
		data
	}
}

export const setPU4NeverShow = data => ({
	type: SET_PU4_NEVER_SHOW,
	data,
	meta: {
		method: 'POST',
		url: API_PATH.setPU4NeverShow,
		query: {},
		callback: data?.callback || null
	}
})

export const increaseCoachMark = data => ({
	type: INCREASE_COACH_MARK,
	data,
	meta: {
		method: 'POST',
		url: API_PATH.increaseCoachMark,
		query: {},
		callback: data?.callback || null
	}
})

export const getWinnerMonth = data => {
	return {
		type: GET_WINNER_MONTH,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.getMonthWinner,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}

export const updateProfileName = data => ({
	type: UPDATE_INFORMATION_NAME,
	data,
	meta: {
		method: 'POST',
		url: API_PATH.updateInformationName,
		query: {},
		callback: data?.callback || null
	}
})

export const getTotalPieceCollected = data => {
	return {
		type: TOTAL_PIECECOLLECTED,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.totalPieceCollected,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}